import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar/Sidebar';
import './Dashboard.css';

function Dashboard() {
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  // Função para alternar a sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="dashboard-container">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <main className={`content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <h1>Dashboard</h1>
        <p>Bem-vindo ao painel principal!</p>
      </main>
    </div>
  );
}

export default Dashboard;
